import React, { useCallback, useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import { DocumentScanner, FlashlightOff, FlashlightOn, Videocam, VideoCameraBack, VideoCameraFront, VideocamOff } from "@mui/icons-material";

import { CodeScannerMode, useCodeScannerOptions } from "./code-scanner-settings-context";

export const CodeScannerMenu = () => {
    const [cameraListVisible, setCameraListVisible] = useState(false);
    const scannerOptions = useCodeScannerOptions();

    const handleCameraScannerSelected = useCallback(() => {
        if (scannerOptions.scanMode === CodeScannerMode.CameraScanner) {
            setCameraListVisible(prev => !prev);
        }
        scannerOptions.onScanModeChange(CodeScannerMode.CameraScanner);
    }, [scannerOptions, setCameraListVisible]);

    const handleCameraChanged = useCallback((device: MediaDeviceInfo) => {
        scannerOptions.onPreferredCameraDeviceChange(device);
        setCameraListVisible(false);
    }, [scannerOptions]);
    const handleKeyboardScannerSelected = useCallback(() =>
        scannerOptions.onScanModeChange(CodeScannerMode.BarcodeScanner),
        [scannerOptions]);

    useEffect(() => {
        if (scannerOptions.scanMode === CodeScannerMode.BarcodeScanner) {
            setCameraListVisible(false);
        }
    }, [scannerOptions.scanMode]);

    return <div className={"scanner-menu"}>
        <div className={"scanner-menu__row"}>
            <Button onClick={handleCameraScannerSelected}
                    className={!scannerOptions.isCameraScannerAvailable ? "scanner-menu__button--disabled" : ""}
                    variant={scannerOptions.scanMode === CodeScannerMode.CameraScanner ? "contained" : "outlined"}
                    disabled={!scannerOptions.isCameraScannerAvailable}
                    size={"large"}>
                {scannerOptions.isCameraScannerAvailable ?
                    <Videocam fontSize={"medium"} /> :
                    <VideocamOff fontSize={"medium"} />}
            </Button>
            <Button onClick={handleKeyboardScannerSelected}
                    variant={scannerOptions.scanMode === CodeScannerMode.BarcodeScanner ? "contained" : "outlined"}
                    size={"large"}>
                <DocumentScanner fontSize={"medium"} />
            </Button>
            {scannerOptions.scanMode === CodeScannerMode.CameraScanner &&
                <Button variant={scannerOptions.activeCameraTorchStatus === "on" ? "contained" : "outlined"} size={"large"}
                        disabled={scannerOptions.activeCameraTorchStatus === "unsupported"}
                        onClick={() => scannerOptions.onTorchToggle()}>
                    {scannerOptions.activeCameraTorchStatus === "unsupported" || !scannerOptions.activeCameraTorchStatus ?
                        <FlashlightOff fontSize={"medium"} /> :
                        <FlashlightOn fontSize={"medium"} />}
            </Button>}
        </div>
        {scannerOptions.cameraDevicesList && cameraListVisible &&
            scannerOptions.cameraDevicesList.map(camera =>
                    <div className={"scanner-menu__row scanner-menu__row--camera"}
                         key={`camera-${camera.deviceId}`}
                         onClick={() => handleCameraChanged(camera)}>
                        {camera.label.toLowerCase().indexOf("front") ?
                            <VideoCameraBack fontSize={"medium"} /> :
                            <VideoCameraFront fontSize={"medium"} />}
                        <Typography className={"scanner-menu__label"}>
                            {camera.label}
                        </Typography>
                    </div>)}
    </div>;
};
